import React, {useEffect, useState} from "react"
import { connect } from "react-redux"
import classNames from "classnames"

import {
  getSyncSearchFormValuesByState,
  ADVANCED_SEARCH_SCOPE_CONFIGURATION_FIELDS as SCOPE_CONFIGURATION_FIELDS,
  getDefaultOrderByParams,
  getSearchFormValuesByState
} from "../../../../helpers/configurationHelper";

import CheckoutButton from "../../../shared/checkout/CheckoutButton";
import {ConfigurationsType} from "../../../../types/configurations";
import {AllInterferometricStacksType, ProductImageStacType} from "../../../../types/product";
import {ShapeType} from "../../../../types/shape";
import ClearProductSelectionsButton from "../../../shared/buttons/ClearProductSelectionsButton";
import {
  toggleSidebarProcessingParametersAction,
  updateFormDataPayloadAction
} from "../../../../state/application/actions";
import {isInterferometricStackSearchResults} from "../../../../helpers/searchResultsHelper";
import {AppParametersType} from "../../../../types/app";
import DownLoadSearchResultsButton from "../../../shared/checkout/DownLoadSearchResultsButton";
import translations from "../../../../translations";
import {errorToastNotification} from "../../../../helpers/toastNotificationHelper";
import {searchDispatchAction} from "../../../../state/product/dispatchActions";

interface PropsType {
  configurations: ConfigurationsType,
  selectedProducts: ProductImageStacType[],
  syncSearchFormValues: any,
  formData: any,
  selectedArea: ShapeType,
  toggleSidebarProcessingParametersHandler: any,
  containerClassName: string,
  allInterferometricStacks: AllInterferometricStacksType,
  isInterferometricStackOrder: boolean,
  appParameters: AppParametersType,
  SearchFilterForDownload: any,
  language: any,
  updateFormDataPayloadActionHandler: any,
  searchDispatchActionHandler: any,
  searchFormValues: any,
  isInterferometricStackSearch: boolean,
  searchByProducts: boolean,
  searchProductIds: any,
  detailsSidebarCase?: boolean,
  hideBaselineFilter?: boolean,
}

const FooterButtons = ({
  configurations,
  selectedProducts,
  toggleSidebarProcessingParametersHandler,
  syncSearchFormValues,
  formData,
  selectedArea,
  containerClassName,
  allInterferometricStacks,
  isInterferometricStackOrder,
  appParameters,
  language,
  updateFormDataPayloadActionHandler,
  searchDispatchActionHandler,
  searchFormValues,
  isInterferometricStackSearch,
  searchByProducts,
  searchProductIds,
  detailsSidebarCase,
  hideBaselineFilter,
}: PropsType) => {
  /** Reset-master-id-case during baseline-filtering */
  const [resetMasterId, setResetMasterId] = useState(false);
  /** Prevent baseline-filtering/search useEffect-loop */
  const [baselineFilterLimiter, setBaselineFilterLimiter] = React.useState({state: false, count: 1});

  const baselineFilterClickHandler = React.useCallback((event?: React.MouseEvent<HTMLButtonElement, MouseEvent>, toggleBaselineFiltering?: boolean) => {
    const baselineFilterData = {
      masterId: resetMasterId ? undefined : formData.masterId,
      slaveId: (selectedProducts && selectedProducts.length) ? selectedProducts.map((product) => product.id) : undefined,
      baselineFilter: false,
      maxBaseline: formData.maxBaseline
    }

    // se il baseline filter NON è attivo...
    let launchSearch = false;

    if (toggleBaselineFiltering) {
      if (baselineFilterData.masterId && formData.maxBaseline) { // se ho tutti i valori mandatori...
        baselineFilterData.baselineFilter = true;
        launchSearch = true;
      } else { // altrimenti, mostro un popup di avviso (e devo fare in modo che siano segnalati gli errori)
        // eslint-disable-next-line no-lonely-if
        if (!formData.masterId && !formData.maxBaseline && !resetMasterId) {
          errorToastNotification(translations("missingMasterAndMaxBaseline", language));
        } else if (!formData.masterId && !resetMasterId) {
          errorToastNotification(translations("missingMaster", language));
        } else if (!formData.maxBaseline) {
          errorToastNotification(translations("missingMaxBaseline", language));
        }
      }
    } else { // altrimenti lo spengo
      // TODO: gestire meglio il caso in cui spengo la ricerca
      // resetto tutte le variabili relative (masterId, slaveId, maxBaseline)
      baselineFilterData.masterId = undefined;
      baselineFilterData.maxBaseline = undefined;
      launchSearch = true;
    }

    if (resetMasterId) {
      baselineFilterData.baselineFilter = false
      launchSearch = true;
      setResetMasterId(false);
    }

    // aggiorno lo state
    updateFormDataPayloadActionHandler(baselineFilterData);

    // lancio la ricerca
    if (launchSearch) {
      searchDispatchActionHandler({
        ...formData,
        ...baselineFilterData,
        token: null,
        orderBy: getDefaultOrderByParams(configurations, searchFormValues, isInterferometricStackSearch, language),
        language,
        searchByProducts,
        searchProductIds
      }, true, isInterferometricStackSearch);
    }
  }, [configurations, formData, isInterferometricStackSearch, language, resetMasterId, searchByProducts, searchDispatchActionHandler, searchFormValues, searchProductIds, selectedProducts, updateFormDataPayloadActionHandler]);

  /** Handle active baselineFiltering */
  const baselineFilteringHandler = React.useCallback(() => {
    const baselineFilterData = {
      masterId: resetMasterId ? undefined : formData.masterId,
      slaveId: (selectedProducts && selectedProducts.length) ? selectedProducts.map((product) => product.id) : undefined,
      baselineFilter: false,
      maxBaseline: formData.maxBaseline
    }

    const missingDataCase = (!formData.masterId || !formData.maxBaseline) && !resetMasterId;

    // Required Fields Validation
    if (missingDataCase) {
      if (!formData.masterId && !formData.maxBaseline) {
        errorToastNotification(translations("missingMasterAndMaxBaseline", language));
      } else if (!formData.masterId) {
        errorToastNotification(translations("missingMaster", language));
      } else if (!formData.maxBaseline) {
        errorToastNotification(translations("missingMaxBaseline", language));
      }

      return;
    }

    if (resetMasterId) {
      baselineFilterData.baselineFilter = false
      setResetMasterId(false);
    } else {
      baselineFilterData.baselineFilter = true;
    }

    searchDispatchActionHandler({
      ...formData,
      ...baselineFilterData,
      token: null,
      orderBy: getDefaultOrderByParams(configurations, searchFormValues, isInterferometricStackSearch, language),
      language,
      searchByProducts,
      searchProductIds
    }, true, isInterferometricStackSearch);
  }, [configurations, formData, isInterferometricStackSearch, language, resetMasterId, searchByProducts, searchDispatchActionHandler, searchFormValues, searchProductIds, selectedProducts]);

  useEffect(() => {
    if (!formData?.baselineFilter) return;
    if (!formData?.maxBaseline) return;
    if (!formData?.masterId) {
      setResetMasterId(true);
    }
    setBaselineFilterLimiter(({count}) => ({state: true, count: count + 1}));
  }, [formData.baselineFilter, formData.masterId, formData.maxBaseline, updateFormDataPayloadActionHandler]);

  useEffect(() => {
    const {state, count} = baselineFilterLimiter;
    if (!state || count % 2 === 0) return;

    baselineFilteringHandler();
    setBaselineFilterLimiter((value) => ({state: true, count: value.count + 1}));
  }, [baselineFilteringHandler, baselineFilterLimiter]);

  const isGeneralInterferometricStackSearch = (hideBaselineFilter && isInterferometricStackSearch);

  const checkoutButton = <CheckoutButton products={selectedProducts} />;
  const downloadResultsButton = <DownLoadSearchResultsButton selectedProducts={selectedProducts} searchFormValues={syncSearchFormValues} selectedArea={selectedArea} configurations={configurations} scopeConfigurationFields={SCOPE_CONFIGURATION_FIELDS} formData={formData} />;
  return (
    <div className={classNames("footer-buttons-container", containerClassName)}>
      {!detailsSidebarCase && <ClearProductSelectionsButton />}

      {!isGeneralInterferometricStackSearch && (
        <div className="ml-3">
          <button
            className={classNames("btn btn-primary", {
              selected: formData?.baselineFilter
            })}
            style={{minWidth: "100px"}}
            type="button"
            onClick={(event) => { baselineFilterClickHandler(event, !formData.baselineFilter) }}
          >
            {translations("baselineFilter", language)}
          </button>
        </div>
      )}

      {!detailsSidebarCase && (
        <>
          <div className="ml-3">
            {checkoutButton}
          </div>

          <div className="ml-3">
            {downloadResultsButton}
          </div>
        </>
      )}

    </div>
  );
};

const mapStateToProps = (state) => ({
  configurations: state.application.configurations,
  syncSearchFormValues: getSyncSearchFormValuesByState(state),
  selectedArea: state.geoMap.lastShape,
  selectedProducts: state.product.selectedProducts,
  allInterferometricStacks: state.product.allInterferometricStacks,
  isInterferometricStackOrder: isInterferometricStackSearchResults(state.product.searchResults),
  appParameters: state.application.appParameters,
  language: state.application.appParameters.language,
  searchFormValues: getSearchFormValuesByState(state),
  isInterferometricStackSearch: state.product.isInterferometricStackSearch,
  searchByProducts: state.geoMap.searchByProducts,
  searchProductIds: state.geoMap.searchProductIds,
});

const mapDispatchToProps = (dispatch) => ({
  toggleSidebarProcessingParametersHandler: (e) => dispatch(toggleSidebarProcessingParametersAction(e)),
  updateFormDataPayloadActionHandler: (maxBaselineData) => dispatch(updateFormDataPayloadAction(maxBaselineData)),
  searchDispatchActionHandler: (formData, isNewSearch, isInterferometricStackSearch, language, searchByProducts, searchProductIds) => dispatch(searchDispatchAction(formData, isNewSearch, isInterferometricStackSearch, language, searchByProducts, searchProductIds)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FooterButtons)
